module.exports = __webpack_public_path__ + "static/media/boat-img-19.7eda4ff2.jpg";